import React from "react";
// ANT DESIGN COMPONENTS
import { Table, Switch } from "antd";
// FILTERS
import FilterSearchText from "../filters/FilterSearchText";
// INTERFACES
import { FormularyHeaderInputBooleanInterface } from "../../../interfaces/Global.interface";

export default function FormularyHeaderInputBoolean({
	columnName,
	inputPlaceholder,
	formAction,
	value,
	onChangeFormValueBoolean,
	variableName,
	itemId,
	onClickCellName = () => {},
	enabledCellClick = false,
	enabledFilter = false,
	filterValue = "",
	setFilterValue = () => {},
	refreshTable = () => {},
}: FormularyHeaderInputBooleanInterface) {
	// ************************************************ */
	// GLOBAL VARIABLES ******************************* */
	const { Column, ColumnGroup } = Table;

	// ************************************************ */
	// USE STATE VARIABLES **************************** */

	// ************************************************ */
	// REDUX SLICE VARIABLES ************************** */

	// ************************************************ */
	// CUSTOM HOOKS *********************************** */

	// ************************************************ */
	// SERVICES AND API CALLS ************************* */

	// ************************************************ */
	// FUNCTIONS ************************************** */

	// ************************************************ */
	// USE EFFECT ************************************* */

	// ************************************************ */
	// COMPONENT ************************************** */
	return (
		<ColumnGroup title={columnName}>
			<Column
				className='generalStyles__hoverCursor'
				onCell={(record: any) => ({
					onClick: () => {
						if (enabledCellClick && formAction === "create") {
							onClickCellName(record);
						}
					},
				})}
				filterDropdown={() => (
					<>
						{enabledFilter && (
							<FilterSearchText
								placeHolder={inputPlaceholder}
								filterValue={filterValue}
								setFilterValue={setFilterValue}
								refreshTable={refreshTable}
								refreshRequireParamenters
							/>
						)}
					</>
				)}
				filterIcon={enabledFilter ? undefined : () => null}
				title={
					<Switch
						checked={formAction === "create" ? value : false}
						onChange={(checked) => {
							onChangeFormValueBoolean(checked, variableName);
						}}
					/>
				}
				dataIndex={variableName}
				key={variableName}
				render={(text, record: any) => (
					<div>
						{formAction === "edit" && record.id === itemId ? (
							<Switch
								checked={value}
								onChange={(checked) => {
									onChangeFormValueBoolean(checked, variableName);
								}}
							/>
						) : (
							<Switch checked={text} disabled />
						)}
					</div>
				)}
			/>
		</ColumnGroup>
	);
}
